import { type TypedDocumentNode, gql } from '@apollo/client';

import { HighScarcityStatus } from './HighScarcityStatus';
import type {
  TRANSACTION_HISTORY_CONTENT_QUERYVariables,
  TRANSACTION_HISTORY_CONTENT_QUERY as TRANSACTION_HISTORY_CONTENT_QUERY_TYPE,
} from './__generated__/query.graphql';

export const TRANSACTION_HISTORY_CONTENT_QUERY = gql`
  query TRANSACTION_HISTORY_CONTENT_QUERY {
    currentUser {
      slug
      highScarcityStatus {
        current {
          status
        }
        previous {
          status
        }
        spendLeftToNextStatus {
          eurCents
        }
      }
      ...HighScarcityStatus_highScarcityStatus
    }
  }
  ${HighScarcityStatus.fragments.highScarcityStatus}
` as TypedDocumentNode<
  TRANSACTION_HISTORY_CONTENT_QUERY_TYPE,
  TRANSACTION_HISTORY_CONTENT_QUERYVariables
>;
